module.exports = __webpack_public_path__ + "img/5-on.5d5b9796.png";